import React from 'react';

import { IRouter } from '@routers/interface';

export const routerPage403: IRouter = {
  path: '/403',
  masterLayout: false,
  loader: React.lazy(() => import('./index')),
};
